// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.day-selector {
  display: flex;
  margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  .day-selector {
    flex-direction: column;
  }
}
.day-selector div {
  width: 150px;
  text-align: center;
  padding: 10px 20px;
  background: #bdc3c7;
  color: white;
  caret-color: transparent;
}
@media screen and (max-width: 768px) {
  .day-selector div {
    width: 100%;
  }
}
.day-selector div.active {
  background-color: #ff0059;
}
.day-selector div:hover {
  cursor: pointer;
  opacity: 0.8;
}

.selected-days {
  margin-top: 20px;
}
.selected-days .day-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.selected-days .day-row label {
  min-width: 80px;
}
.selected-days .day-row .time-select {
  display: flex;
  align-items: center;
  margin-left: 10px;
  gap: 10px;
}
.selected-days .day-row .time-select select {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 33px;
  padding: 0 5px 0 10px;
}
.selected-days .close-icon {
  margin-left: 10px;
}
.selected-days .close-icon:hover {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
